import { render } from "./CenterForm.vue?vue&type=template&id=523b8d9a"
import script from "./CenterForm.vue?vue&type=script&lang=ts"
export * from "./CenterForm.vue?vue&type=script&lang=ts"
script.render = render

export default script